import { render, staticRenderFns } from "./TireMaintenance.vue?vue&type=template&id=de47e148&scoped=true"
import script from "./TireMaintenance.vue?vue&type=script&lang=js"
export * from "./TireMaintenance.vue?vue&type=script&lang=js"
import style0 from "./TireMaintenance.vue?vue&type=style&index=0&id=de47e148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de47e148",
  null
  
)

export default component.exports